import React, { Component } from 'react'
import Router from 'next/router'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { Modal, IonIcon, Button } from 'controls'
import { getMessage } from './messages'
import { getUserProfile } from 'app/selectors'
import { PLANS } from 'services/config'
import { getUserPlans, showNotYetPaidModalSelector } from 'app/selectors'
import { companyConfig } from 'globalConfigApp'

import styles from './styles'

class NotYetPaidModal extends Component {
  static propTypes = {
    hasPaid: PropTypes.bool,
    userStatus: PropTypes.string
  }

  componentDidMount() {
    const { hasPaid, token, mailbox, userPlans, userStatus, hasKit } = this.props

    if (
      (hasPaid && !mailbox && (userPlans.includes(PLANS.FULL_SERVICE) || userPlans.includes(PLANS.IN_HOUSE_FULL))) ||
      (userStatus !== 'ACTIVE' && userStatus !== 'BLOCKED')
    ) {
      Router.replace(
        {
          pathname: '/dashboard/broker-info',
          query: {
            t: token
          }
        },
        {
          pathname: `/dashboard/broker-info`,
          query: {
            t: token
          }
        }
      )
    }
  }

  render() {
    const { hasPaid, userStatus, blockedReason, userPlans, showNotYetPaidModal } = this.props

    if (!showNotYetPaidModal) {
      return null
    }
    return (
      <Modal
        isOpen={(!hasPaid && (userPlans.includes(PLANS.FULL_SERVICE) || userPlans.includes(PLANS.IN_HOUSE_FULL))) || userStatus !== 'ACTIVE'}
        showCloseButton={false}
      >
        <section className="content">
          <h3>
            <IonIcon icon="ios-speedometer" /> ¡Bienvenido a tu dashboard!
          </h3>
          <p>{getMessage(hasPaid, userStatus, blockedReason)}</p>
          <p className="highlight">
            Si tienes dudas, escríbenos a{' '}
            <a
              href={`mailto:info@${companyConfig.companyDomain}?Subject=${companyConfig.name} Acceso`}
              target="_top"
              className="link"
            >
              {`info@${companyConfig.companyDomain}`}
            </a>
          </p>
          {(!hasPaid || blockedReason === 'BROKER_HAS_NOT_PAID') && (
            <Button
              href="/dashboard/payments"
              color="primary"
              fullWidth
              className="logout"
            >
              Pagar
            </Button>
          )}
        </section>
        <style jsx>{styles}</style>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
  const profile = getUserProfile(state)
  return {
    hasPaid: Boolean(profile.hasPaid),
    userStatus: profile.status,
    hasKit: profile.hasKit,
    blockedReason: profile.blockedReason,
    mailbox: profile.mailbox,
    userPlans: getUserPlans(state),
    showNotYetPaidModal: showNotYetPaidModalSelector(state),
    token: state.auth.token
  }
}

export default connect(mapStateToProps)(NotYetPaidModal)
